/**
 * Tiny UI slice — current active tab.
 *
 * Persisted in localStorage via the global store (wave 13). Other UI
 * preferences (auto-logout cache) live in different slices that the
 * persist middleware whitelists explicitly.
 */

export interface UiState {
  activeTab: string;
}

export interface UiActions {
  setActiveTab: (tab: string) => void;
}

export type UiSlice = UiState & UiActions;

export const initialUiState: UiState = {
  activeTab: 'home',
};

export const createUiSlice =
  <T extends UiSlice>() =>
  (
    set: (
      partial: Partial<T> | ((state: T) => Partial<T>),
      replace?: boolean,
    ) => void,
  ): UiSlice => ({
    ...initialUiState,
    setActiveTab: (tab) => set({ activeTab: tab } as Partial<T>),
  });
